






































import {
  defineComponent, computed, PropType,
} from '@vue/composition-api';
import type { RightSummaryType } from '@/api/rights/types';
import {
  rightsBottomDescriptionEnum,
  rightsServiceMapping,
} from '../rightsServiceMapping';

interface Props {
  rightSummary: RightSummaryType;
  tabRightText?: string;
}

export default defineComponent({
  name: 'NormalTabContent',
  props: {
    rightSummary: {
      type: Object as PropType<RightSummaryType>,
      required: true,
    },
    tabRightText: {
      type: String,
      default: '普通申请',
    },
  },
  emits: ['tabChange'],
  setup(props: Props, { emit }: { emit: (event: string, ...args: unknown[]) => void }) {
    /** 获取当前权益服务文案 */
    const currentRightsServiceText = computed(
      () => rightsServiceMapping.getRightsServiceText(props.rightSummary),
    );

    /** 普通通道描述是否显示 */
    const normalDescription = computed(
      () => currentRightsServiceText.value.rightsBottomDescription
        === rightsBottomDescriptionEnum.EQUITY_PROVIDER
        || currentRightsServiceText.value.rightsBottomDescription
        === rightsBottomDescriptionEnum.CHANNEL_EQUITY,
    );

    /** 普通通道描述项 */
    const normalDescriptionItems = computed(() => {
      if (currentRightsServiceText.value.rightsBottomDescription
        === rightsBottomDescriptionEnum.EQUITY_PROVIDER) {
        return [
          '不可享受哈啰定制权益',
          '不可享受专属的吃喝玩乐权益',
        ];
      }
      if (currentRightsServiceText.value.rightsBottomDescription
        === rightsBottomDescriptionEnum.CHANNEL_EQUITY) {
        return [
          '不可享受专属的生活权益',
          '不可享受专属权益服务',
        ];
      }
      return [];
    });

    /** 处理 tab 切换 */
    const handleTabChange = () => {
      emit('tabChange');
    };

    return {
      currentRightsServiceText,
      normalDescription,
      normalDescriptionItems,
      handleTabChange,
    };
  },
});
